import { useState, useEffect } from 'react';

export function useRoute(orderId) {
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderId) return;

    const fetchRoute = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/api/routing/order/${orderId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        
        const data = await res.json();
        // Map geometry to path for the map component
        if (data.route && data.route.geometry) {
          data.route.path = data.route.geometry;
        }
        setRoute(data);
      } catch (err) {
        console.error('Failed to fetch route:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRoute();
  }, [orderId]);

  return { route, loading, error };
}

